import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e9181e94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "renewal-service-wrap" }
const _hoisted_2 = { class: "tips-box" }
const _hoisted_3 = { class: "tips-header" }
const _hoisted_4 = { class: "tips-content" }
const _hoisted_5 = { class: "cm-ui-mt5 cm-ui-mb5" }
const _hoisted_6 = {
  key: 1,
  class: "cm-ui-mt5 cm-ui-mb5"
}
const _hoisted_7 = { class: "service-page-title" }
const _hoisted_8 = {
  key: 0,
  class: "selection-bar"
}
const _hoisted_9 = { class: "service-name-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ServiceEnum = _resolveComponent("ServiceEnum")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/dashboard/service/subscribe-details/_components/_images/tips",
          monochrome: ""
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsHeader')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isPrivateLike)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsContentPublicLead')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsLine1')), 1),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsLine2BeforeLink')), 1),
                _createElementVNode("a", {
                  href: "/dashboard/service-subscribe",
                  class: "cm-link-light underline",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onServiceSubscribeLinkClick && _ctx.onServiceSubscribeLinkClick(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsLine2Link')), 1),
                _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsLine2AfterLink')), 1)
              ]),
              _createElementVNode("div", null, [
                (!_ctx.isPrivateLike)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine4Public')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine4Private')), 1)
                    ], 64))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('subscribeDetails.renewal.tipsPrivateLead')), 1))
      ])
    ]),
    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('subscribeDetails.renewal.expiredDetailTitle')), 1),
    (!_ctx.isPrivateLike)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createVNode(_component_el_button, {
            type: "text",
            disabled: !_ctx.selectedCount,
            onClick: _ctx.handleCancelSelect
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.renewal.cancelSelect')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "text",
            disabled: !_ctx.selectedCount,
            onClick: _ctx.toggleShowSelected
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isShowSelection ? _ctx.$t('subscribeDetails.renewal.closeSelectedWithCount', { n: _ctx.selectedCount }) : _ctx.$t('subscribeDetails.renewal.viewSelectedWithCount', { n: _ctx.selectedCount })), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_table, {
      "empty-text": _ctx.$t('common.noData'),
      class: "table-wrap",
      ref: "tableNode",
      data: _ctx.tableData,
      width: "100%",
      height: "100%",
      "row-key": "price_id",
      onSelectionChange: _ctx.handleSelectionChange
    }, {
      default: _withCtx(() => [
        (!_ctx.isPrivateLike)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              "reserve-selection": "",
              width: "50",
              fixed: "",
              selectable: _ctx.isRenewalRowSelectable
            }, null, 8, ["selectable"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colServiceName'),
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ServiceEnum, {
                services: [_ctx.serviceDisplayName(scope.row)]
              }, null, 8, ["services"]),
              (!_ctx.isPrivateLike && _ctx.isAiAssistantSubscribeItem(scope.row))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "cm-link-light underline service-renew-btn",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openQidianOnlineService && _ctx.openQidianOnlineService(...args)), ["stop"]))
                  }, _toDisplayString(_ctx.t('subscribeDetails.renewal.contactRenew')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colSubscribeTime'),
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.formatTimeStamp(scope.row.subscription_time, 'YYYY-MM-DD HH:mm')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colOrigDuration'),
          "min-width": "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.cycle_count) + _toDisplayString(_ctx.DateKindLabel[scope.row.date_kind]), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colOrigCount'),
          "min-width": "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.terminal_count) + _toDisplayString(_ctx.$t('subscribeDetails.renewal.terminalUnit')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colExpireTime'),
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.formatTimeStamp(scope.row.expire_time, 'YYYY-MM-DD')), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["empty-text", "data", "onSelectionChange"])
  ]))
}